// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DateFns = require("date-fns");
let CalendarDate = require("../../reason/common/types/CalendarDate.bs.js");

function formatDate(date) {
  return DateFns.format(CalendarDate.toLocalDate(date), "MMM d, YYY");
}

exports.formatDate = formatDate;
/* date-fns Not a pure module */
